/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".tab-content[_ngcontent-%COMP%]{display:block;margin-top:1rem}.large-title[_ngcontent-%COMP%]{font-size:18px}"];
export { styles as styles };

